import { NavDataType } from "../../../constants/common";
import { PATIENT_PATHS } from "../../../constants/paths";

export const PATIENT_TABS: NavDataType[] = [
  {
    label: "Dashboard",
    path: PATIENT_PATHS.DASHBOARD,
    value: "dashboard",
  },
  {
    label: "Appointments",
    path: PATIENT_PATHS.APPOINTMENTS,
    value: "appointments",
  },
  {
    label: "Providers",
    path: PATIENT_PATHS.PROVIDERS,
    value: "providers",
  },
  {
    label: "Communication",
    path: PATIENT_PATHS.COMMUNICATION + "/chat",
    value: "communication",
  },
  {
    label: "Billing",
    path: PATIENT_PATHS.BILLING,
    value: "billing",
  },
  {
    label: "Documents",
    path: PATIENT_PATHS.DOCUMENTS,
    value: "documents",
  },
  {
    label: "Tasks",
    path: PATIENT_PATHS.TASKS,
    value: "tasks",
  },
  {
    label: "Health Record",
    path: PATIENT_PATHS.HEALTH_RECORD,
    value: "health-record",
    children: [
      {
        label: "Medication",
        path: PATIENT_PATHS.INTAKE,
        value: "medication",
      },
      {
        label: "Immunisation",
        path: PATIENT_PATHS.INTAKE,
        value: "immunisation",
      },
    ],
  },
  {
    label: "Settings",
    path: PATIENT_PATHS.SETTINGS,
    value: "settings",
  },
];
